var fakeData = [
    {
        crsName : 'Web-development',
        instructor : 'Abul Hossain',
        lecture : 21 ,
        lectureTime : 21 ,
        price : 2100 ,
        img : 'https://www.fakepersongenerator.com/Face/male/male1084265411285.jpg'

    },
    {
        crsName : 'PhotoShot Expert',
        instructor : 'Sajib',
        lecture : 14 ,
        lectureTime : 7 ,
        price : 1000 ,
        img : 'https://www.fakepersongenerator.com/Face/female/female20161024684813690.jpg'

    },
    {
        crsName : 'How to Art',
        instructor : 'Tanvir',
        lecture : 8 ,
        lectureTime : 4 ,
        price : 1100 ,
        img : 'https://www.fakepersongenerator.com/Face/male/male20151083607620392.jpg'

    },
    {
        crsName : 'Photo Deginer',
        instructor : 'Uday',
        lecture : 6 ,
        lectureTime : 3 ,
        price : 1100 ,
        img : 'https://www.fakepersongenerator.com/Face/male/male1084925773956.jpg'

    },
    {
        crsName : 'Web-development',
        instructor : 'shofiq',
        lecture : 30 ,
        lectureTime : 21 ,
        price : 3000 ,
        img : 'https://www.fakepersongenerator.com/Face/male/male1084325130158.jpg'

    },
    {
        crsName : 'Learn-React',
        instructor : 'Anowar',
        lecture : 17 ,
        lectureTime : 10 ,
        price : 900 ,
        img : 'https://www.fakepersongenerator.com/Face/male/male2015108361735370.jpg'

    },
    {
        crsName : 'Learn-Python',
        instructor : 'sakira',
        lecture : 26 ,
        lectureTime : 20 ,
        price : 4000 ,
        img : 'https://www.fakepersongenerator.com/Face/female/female201610250327172.jpg'

    },
    {
        crsName : 'Robotics',
        instructor : 'Anushka',
        lecture : 40 ,
        lectureTime : 30 ,
        price : 6000 ,
        img : 'https://www.fakepersongenerator.com/Face/female/female20171026200116944.jpg'

    },
    {
        crsName : 'Be a Coding Expert',
        instructor : 'Hridoy',
        lecture : 4 ,
        lectureTime : 1 ,
        price : 1000 ,
        img : 'https://www.fakepersongenerator.com/Face/male/male1085042420471.jpg'

    },
    {
        crsName : 'Microsoft word Expert',
        instructor : 'Hasan',
        lecture : 25 ,
        lectureTime : 2 ,
        price : 600 ,
        img : 'https://www.fakepersongenerator.com/Face/male/male1084265411285.jpg'

    },
]

export default fakeData ;

